import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { ROOT_ROUTE } from '../../constants';
import wideLogo from '../../assets/imgs/KultuuriKava-Logo-912px.png';
import { setWhereFilter, setKindFilter, setDateFilter } from '../../redux/actions';

const Logo = () => {
    const rootUrl = `${ROOT_ROUTE}/events`;
    const dispatch = useDispatch();
 
    const clearFilters = () => {
        dispatch(setWhereFilter(null));
        dispatch(setKindFilter(null));
        dispatch(setDateFilter(null));
    }
    return (
        <div className="logo flex-r">
            <Link to={rootUrl} onClick={clearFilters}>
                <div>
                    <img 
                        className="logo-image"
                        src={wideLogo} 
                        alt="Logo" />
                </div>   
            </Link>         
    </div>
    );
}

export default Logo;